"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.playerInfoCommands = exports.PlayerInfoUpdateCommandActionTypesArray = exports.playerInfoUpdateCreators = exports.setSpectatingIdCommand = exports.updateShopLockCommand = exports.updateCardsCommand = exports.initialSpectatingState = exports.initialCardShopState = void 0;
const api_1 = require("@cc-plugins/api");
const playerInfoCommands_1 = require("./playerInfoCommands");
Object.defineProperty(exports, "playerInfoCommands", { enumerable: true, get: function () { return playerInfoCommands_1.playerInfoCommands; } });
exports.initialCardShopState = {
    cards: [],
    locked: false,
};
exports.initialSpectatingState = {
    id: null,
};
exports.updateCardsCommand = (0, api_1.networkedAction)("cards/updateCardsCommand");
exports.updateShopLockCommand = (0, api_1.networkedAction)("cards/updateShopLockCommand");
exports.setSpectatingIdCommand = (0, api_1.networkedAction)("spectating/setSpectatingIdCommand");
exports.playerInfoUpdateCreators = [
    exports.updateCardsCommand,
    exports.updateShopLockCommand,
    exports.setSpectatingIdCommand,
    ...Object.values(playerInfoCommands_1.playerInfoCommands),
];
exports.PlayerInfoUpdateCommandActionTypesArray = exports.playerInfoUpdateCreators.map((c) => c.type);
